import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useStore } from '../../stores/store';
import { AppRoute, SearchParam } from '../../constants/route';
import {
  generateLocaleRoute,
  generateMyRoute,
} from '../../utils/uri/uri.utils';
import PageLoader from '../page-loader/page-loader.component';

interface Props {
  children?: React.ReactNode;
}

// /auth route should be only allowed when user is not logged in
const UnauthorizedRoute = ({ children }: Props) => {
  const { searchParams } = new URL(window.location.href);
  const redirect = searchParams.get(SearchParam.REDIRECT);
  const {
    parcelCreationStore: { setIsParcelCreationInProgress },
    parcelListStore: { fetchParcels },
    userStore: { user, loginGup },
  } = useStore();

  const auth = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsParcelCreationInProgress(false);
  }, [setIsParcelCreationInProgress]);

  const allowAuthPage = useMemo(
    () => !auth.isAuthenticated,
    [auth.isAuthenticated]
  );

  useEffect(() => {
    if (allowAuthPage || auth.isLoading) return;

    const navigateToNewRoute = async () => {
      let newRoute = redirect;

      if (newRoute) {
        navigate(newRoute, { replace: true });
      }

      newRoute = generateLocaleRoute();
      navigate(newRoute, { replace: true });

      // Keep the below logic for some time

      // // Show drafts only in case no created parcel and at lease one draft parcel
      // const created = await fetchParcels(
      //   {
      //     page: 1,
      //     perPage: 1,
      //     filter: ['all'],
      //   },
      //   undefined,
      //   undefined,
      //   false
      // );
      // const drafts = await fetchParcels(
      //   {
      //     page: 1,
      //     perPage: 1,
      //     filter: ['draft'],
      //   },
      //   undefined,
      //   undefined,
      //   false
      // );
      // const hasCreated = created && created.length > 0;
      // const hasDraft = drafts && drafts.length > 0;

      // const onlyDrafts = !hasCreated && hasDraft;
      // if (onlyDrafts) {
      //   newRoute = generateMyRoute(AppRoute.DRAFTS);
      // } else {
      //   newRoute = generateMyRoute(AppRoute.PARCEL_LIST);
      // }

      // navigate(newRoute, { replace: true });
    };

    navigateToNewRoute();
  }, [allowAuthPage, navigate, fetchParcels, redirect, user, auth.isLoading]);

  useEffect(() => {
    if (!allowAuthPage || auth.isLoading || auth.activeNavigator || children) {
      return;
    }

    loginGup({
      auth,
      redirectUri: generateMyRoute(AppRoute.PARCEL_LIST),
    });
  }, [allowAuthPage, auth, children, loginGup]);

  if (allowAuthPage && !auth.isLoading) {
    if (children) return children;
  }

  return <PageLoader />;
};

export default observer(UnauthorizedRoute);
